
import { BASE_URL } from "../../../helpers/config";
import { showToast, showAlert } from "../../../utils/helpers/ShowToast";
import authorizedAxios from "../../../helpers/authorizedAxios";
export const SET_PROVINCES = "SET_PROVINCES";
export const SET_PROVINCES_LOADING = "SET_PROVINCES_LOADING";
export const SET_PROVINCES_ERROR = "SET_PROVINCES_ERROR";

export const fetchProvinces = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PROVINCES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/provinces", { params: { limit, page, search } });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PROVINCES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PROVINCES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PROVINCES_LOADING, status: false });
    }
  };
};

export const getProvinceById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROVINCES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/provinces/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PROVINCES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PROVINCES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PROVINCES_LOADING, status: false });
    }
  };
};

export const addProvince = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROVINCES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/provinces`, data), {
        loading: "Menyimpan data...",
        success: "Data provinsi berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data provinsi berhasil ditambahkan!"
        });
        dispatch(fetchProvinces());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PROVINCES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PROVINCES_LOADING, status: false });
    }
  };
};

export const updateProvince = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROVINCES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/provinces/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data provinsi berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data provinsi berhasil diupdate!"
        });
        dispatch(fetchProvinces());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PROVINCES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PROVINCES_LOADING, status: false });
    }
  };
};

export const deleteProvince = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROVINCES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/provinces/${id}`), {
        loading: "Menghapus data...",
        success: "Data provinsi berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data provinsi berhasil dihapus!"
        });
        dispatch(fetchProvinces());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PROVINCES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_PROVINCES_LOADING, status: false });
    }
  };
};
